BuyButton = window.BuyButton ?= {}

MagicEventBus = require 'magic-event-bus/lib/frizzle.js'
BuyButton.View = require './views/buy_button'
MultiOptionModal = require './multi_option_modal'

resetMultiOptionLink = ->
  # wait until pageshow to reset radio buttons
  $(window).on 'pageshow', ->
    $buyLink = $('#options a.buy-button').attr('href')
    $('#options input[value="' + $buyLink + '"]').prop('checked', true)

BuyButton.init = (payload, done) ->
  {buyButton} = payload
  @eventBus = new MagicEventBus()

  if buyButton.multiOptionEnabled
    resetMultiOptionLink()

  @view = new BuyButton.View
    multiOptionEnabled: buyButton.multiOptionEnabled

  MultiOptionModal.init(payload)
  done()

module.exports = BuyButton
